var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "585.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 585.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4557 1989 c-100 -24 -227 -113 -279 -197 -12 -20 -198 -430 -414 -912 l-391 -875 275 -3 c152 -1 279 1 282 5 4 5 146 320 316 701 170 380 311 692 314 692 4 0 145 -312 315 -692 169 -381 311 -696 315 -701 3 -4 130 -6 282 -5 l276 3 -387 866 c-213 477 -399 886 -413 910 -33 55 -121 140 -176 168 -90 46 -220 62 -315 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 1951 c-159 -45 -320 -180 -389 -324 -89 -185 -86 -385 9 -566 62 -118 177 -227 291 -276 113 -49 108 -49 547 -55 l419 -5 29 -33 c43 -47 41 -102 -5 -148 l-34 -34 -631 0 -631 0 0 -255 0 -255 643 0 c712 0 725 1 852 64 163 81 283 229 331 410 18 68 17 216 -1 295 -32 136 -139 285 -263 367 -31 21 -95 52 -142 68 l-85 31 -411 5 c-380 5 -413 6 -432 23 -70 64 -44 171 49 197 20 6 269 10 621 10 l588 0 0 250 0 250 -647 -1 c-583 0 -654 -2 -708 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2770 1954 c-295 -63 -549 -261 -680 -529 -59 -121 -87 -219 -100 -346 -51 -521 323 -994 845 -1069 46 -6 166 -10 279 -8 l199 3 113 244 c63 135 114 248 114 253 0 4 -141 8 -313 8 -341 0 -384 5 -480 58 -321 175 -336 627 -27 824 99 63 136 68 521 68 l349 0 0 255 0 255 -377 -1 c-283 0 -394 -4 -443 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndice);
export default __webpack_public_path__ + "static/media/indice.e765a6fc8fc45e174a73e16f8efa643f.svg";
export { ForwardRef as ReactComponent };